import React, { useEffect } from 'react';

const SampleForm = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'wf_anal';
    script.src =
      'https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=094608c0e96f540b7ee4867d96dbe58f4c08d0439ebea05d28141338f76a56b0b24893e905c959dbbc7d02218c680cd5gid549bc47ce84250966991f40db53423caf59af0eb04c15fb2a73044cf43cd789agid14fe92bca9fd4234b83c54bd0a4854cb6fd663b94c6013ef70bd7c691b181900gid2e83c0df2cc0272bbbdc626a8cadda02c34dfdc9fbe18d7cf67977675f507bd1&tw=4fe228d39ced2639610beda4b24913a8f8a344dd554037bf27d84cdd4bbd2395';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.getElementById('wf_anal')?.remove();
    };
  }, []);

  return (
    <div className='contactForm formtablet botFormStyle'>
      <h1>Request Us</h1>
      <div
        id='crmWebToEntityForm'
        className='zcwf_lblLeft crmWebToEntityForm'
        style={{ backgroundColor: '#FFFFFF', color: 'black', maxWidth: '600px' }}
      >
        <form
          id='webform6682728000000522650'
          action='https://crm.zoho.com/crm/WebToLeadForm'
          method='POST'
          name='WebToLeads6682728000000522650'
          acceptCharset='UTF-8'
        >
          <input type='hidden' name='xnQsjsdp' value='cc75b21a3b57d58e1a630c26d790ecb48fddf12a15ff1e82622ecac4e58a03d8' />
          <input type='hidden' name='zc_gad' id='zc_gad' value='' />
          <input type='hidden' name='xmIwtLD' value='12f57076529e064a0629e9a0784f8a42d95c0a7bce54ab440e6309790103bb7cc4780b752dda210ceb33e1169358f9bc' />
          <input type='hidden' name='actionType' value='TGVhZHM=' />
          <input type='hidden' name='returnURL' value='https://astronglobal.com/get-a-sample' />

          <div className='zcwf_row'>
            <div className='zcwf_col_lab'>
              <label htmlFor='First_Name'>First Name <span style={{ color: 'red' }}>*</span></label>
            </div>
            <div className='zcwf_col_fld'>
              <input className='form-control' type='text' id='First_Name' name='First Name' maxLength='40' required />
            </div>
          </div>

          <div className='zcwf_row'>
            <div className='zcwf_col_lab'>
              <label htmlFor='Last_Name'>Last Name <span style={{ color: 'red' }}>*</span></label>
            </div>
            <div className='zcwf_col_fld'>
              <input className='form-control' type='text' id='Last_Name' name='Last Name' maxLength='80' required />
            </div>
          </div>

          <div className='zcwf_row'>
            <div className='zcwf_col_lab'>
              <label htmlFor='Email'>Email <span style={{ color: 'red' }}>*</span></label>
            </div>
            <div className='zcwf_col_fld'>
              <input className='form-control' type='email' id='Email' name='Email' maxLength='100' required />
            </div>
          </div>

          <div className='zcwf_row'>
            <div className='zcwf_col_lab'>
              <label htmlFor='Mobile'>Mobile</label>
            </div>
            <div className='zcwf_col_fld'>
              <input className='form-control' type='text' id='Mobile' name='Mobile' maxLength='30' />
            </div>
          </div>

          <div className='zcwf_row'>
            <input
              className='formsubmit zcwf_button btn btn-primary'
              type='submit'
              value='Submit'
              title='Submit'
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default SampleForm;
